var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Prop } from 'vue-property-decorator';
import ErrorHandler from '@/support/ErrorHandler';
import SelectFilter from '@/components/select-filter/SelectFilter';
import { Room } from '@/models/Room';
let AddLevelDialog = class AddLevelDialog extends Vue {
    constructor() {
        super(...arguments);
        this.selectedLevels = [];
    }
    mounted() { }
    close() {
        this.$emit('input', false);
        this.clear();
    }
    update() {
        if (!this.room) {
            return;
        }
        const existingLevels = this.room.levels.map((level) => {
            return level.id;
        });
        const levels = [...this.selectedLevels, ...existingLevels];
        this.room
            .update({ levels })
            .then(() => {
            this.$emit('levelAdded');
            this.$emit('input', false);
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
        this.clear();
    }
    clear() {
        this.selectedLevels = [];
    }
};
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof Room !== "undefined" && Room) === "function" ? _a : Object)
], AddLevelDialog.prototype, "room", void 0);
AddLevelDialog = __decorate([
    Component({
        components: {
            SelectFilter,
        },
    })
], AddLevelDialog);
export default AddLevelDialog;
